exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".fillInTheBlank input{display:inline-block;width:12em;height:26px;padding:6px}.fillInTheBlank input,.fillInTheBlank span.text{margin-right:.6em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/writing/questions/fill_in_the_blank.scss
// module id = 1487
// module chunks = 0